<div class="create-skills">
  <div class="create-skills-wrap">
      <div class="create-skills-left">
          <h2>Idiomas</h2>
      </div>

      <div class="create-skills-right">
          <a (click)="mostrarEdicionIdioma()">+ Añadir Idioma</a>
      </div>
  </div>

    <div>
        <div class="container" *ngIf="!this.mostrarEdicion">
            <div class="row" *ngFor="let idioma of idiomas | paginate: { itemsPerPage: 1, currentPage: noPagina }">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Idioma</label>
                        <input type="text" class="form-control" [value]="idioma.nombre" readonly>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="skill">
                        <p>Nivel</p>
                        <div class="skill-bar skill1 skill3 wow slideInLeft animated" [style.width]="idioma.nivel + '%'">
                            <span class="skill-count1">{{idioma.nivel}}%</span>
                        </div>
                    </div>
                </div>

                <div class="col-lg-12">
                    <div class="form-group">
                        <div class="text-left">
                            <button type="button" class="btn btn-default-ac" (click)="habilitarEdicion(idioma)">Editar Actual</button>
                            <button type="button" class="btn btn-default-ac" (click)="eliminarIdioma(idioma.idIdioma)">Eliminar Actual</button>
                        </div>
                    </div>
                </div>

                <div class="aling-center">
                    <pagination-controls class="page-numbers" (pageChange)="noPagina = $event"
                        [responsive]="true" [previousLabel]="''" [nextLabel]="''"></pagination-controls>
                </div>
            </div>
        </div>

        <div class="container" *ngIf="this.mostrarEdicion">
            <form [formGroup]="formIdi" (ngSubmit)="validarIdioma()">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Idioma</label>
                            <input type="text" class="form-control" formControlName="nombre" [placeholder]="idiomaCandidato.nombre || 'Inglés'">
                            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formIdi.controls.nombre.errors &&
                                (formIdi.controls.nombre.dirty || formIdi.controls.nombre.touched)">
                                <div *ngIf="formIdi.controls.nombre.errors.required">El nombre del idioma es requerida.</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Nivel</label>
                            <input type="text" maxlength="3" class="form-control" formControlName="nivel" [placeholder]="idiomaCandidato.nivel || '90'">
                            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formIdi.controls.nivel.errors &&
                                (formIdi.controls.nivel.dirty || formIdi.controls.nivel.touched)">
                                <div *ngIf="formIdi.controls.nivel.errors.required">El nivel es requerido.</div>
                                <div *ngIf="formIdi.controls.nivel.errors.pattern">Solo se permiten números.</div>
                                <div *ngIf="formIdi.controls.nivel.errors.maxlength">El nivel solo debe contener como máximo 3 dígitos.</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12">
                        <div class="form-group">
                            <div class="text-left">
                                <button type="submit" class="btn create-ac-btn">{{(editarIdioma ? 'Actualizar' : 'Agregar')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
